var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 11.9241C27.2641 12.2504 26.4733 12.4709 25.6433 12.5702C26.4905 12.0623 27.1411 11.2582 27.4474 10.3001C26.642 10.778 25.7608 11.1148 24.8419 11.2958C24.0934 10.4984 23.027 10 21.8468 10C19.5807 10 17.7434 11.8372 17.7434 14.1031C17.7434 14.4248 17.7798 14.7379 17.8497 15.0383C14.4395 14.8671 11.4161 13.2336 9.39227 10.7511C9.03914 11.3571 8.8368 12.062 8.8368 12.8139C8.8368 14.2375 9.56125 15.4934 10.6622 16.2292C10.0106 16.2088 9.37332 16.0328 8.80359 15.7159C8.80336 15.7331 8.80336 15.7503 8.80336 15.7676C8.80336 17.7556 10.2177 19.4141 12.0948 19.791C11.4905 19.9553 10.8567 19.9794 10.2418 19.8613C10.7639 21.4915 12.2793 22.6777 14.0748 22.7109C12.6705 23.8114 10.9012 24.4674 8.97883 24.4674C8.64758 24.4674 8.32102 24.448 8 24.4101C9.81586 25.5743 11.9727 26.2536 14.2898 26.2536C21.8373 26.2536 25.9644 20.0012 25.9644 14.579C25.9644 14.401 25.9605 14.2241 25.9525 14.0481C26.7558 13.4674 27.4492 12.7481 28 11.9241Z",
    fill: "#55ACEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.017f9c243a47b04812fa08e8e15a56df.svg";
export { ForwardRef as ReactComponent };